class ContentModal {
  constructor() {
    this.modal = document.querySelector('[data-content-modal]');
    this.contentContainer = this.modal?.querySelector('[data-content-modal-content]');
    this.overlay = document.querySelector('[data-content-modal-overlay]');
    this.closeBtn = document.querySelector('[data-content-modal-close]');
    this.isOpen = false;

    this.triggers = Array.from(document.querySelectorAll('[data-content-modal-trigger]'));
    this.links = Array.from(document.querySelectorAll('a')).filter((a) => a.href.indexOf('#') >= 0);

    this.init();
  }

  init() {
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    this.triggers.forEach((trigger) => trigger.addEventListener('click', () => this.open(trigger)));
    this.links.forEach((link) => link.addEventListener('click', () => this.open(link)));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });

    document.addEventListener('OpenContentModal', (event) => {
      this.open(event.detail.target);
    });
  }

  open(trigger) {
    if (!trigger || !this.modal || !this.contentContainer) return;

    const pageHandle = trigger.getAttribute('data-page-handle');
    const useStaticContent = trigger.getAttribute('data-use-static-content') || trigger.href.indexOf('#') >= 0;
    const staticContent =
      trigger.parentElement.querySelector('[data-static-content]') ||
      document.querySelector(`[data-static-content="${trigger.getAttribute('href').replace('#', '')}"]`);

    if (!staticContent && !pageHandle) return;

    if (this.closeBtn) {
      this.closeBtn.focus();
    }

    this.trapFocus();

    // Only open modal after content is successfully fetched
    if (pageHandle) {
      this.fetchPageContent(pageHandle, () => {
        this.modal.classList.add('is-open');
        this.modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('overflow-hidden');
        this.isOpen = true;
      });
    } else if (useStaticContent) {
      if (!staticContent) return;

      this.setContent(staticContent.innerHTML);
      const pageTitle = trigger.getAttribute('data-page-title') || staticContent.getAttribute('data-page-title');
      this.setPageTitle(pageTitle);
      this.contentContainer.classList.add('static-content');
      this.modal.classList.add('is-open');
      this.modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
      this.isOpen = true;
    } else {
      console.error('Could not find page handle or content for content modal.');
      return;
    }
  }

  close() {
    if (!this.modal || !this.contentContainer) return;

    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    this.contentContainer.classList.remove('static-content');
    this.isOpen = false;
  }

  trapFocus() {
    const focusableElements = this.modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    this.modal.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            e.preventDefault();
            lastElement.focus();
          }
        } else {
          if (document.activeElement === lastElement) {
            e.preventDefault();
            firstElement.focus();
          }
        }
      }
    });
  }

  setContent(content) {
    if (!this.contentContainer) return;
    this.contentContainer.innerHTML = content;
  }

  fetchPageContent(pageHandle, callback) {
    fetch(`/pages/${pageHandle}.json`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        this.setContent(data.page.body_html);
        this.setPageTitle(data.page.title);

        if (callback && typeof callback === 'function') {
          callback();
        }
      })
      .catch((error) => {
        console.error('Error fetching page content:', error);
        this.setContent('<p>Sorry, there was an error loading the content.</p>');

        if (callback && typeof callback === 'function') {
          callback();
        }
      });
  }

  setPageTitle(title) {
    const pageTitle = this.modal.querySelector('[data-content-modal-title]');
    if (pageTitle && title) {
      pageTitle.textContent = title;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => new ContentModal());
